var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('div',[_c('van-loading',{attrs:{"color":"#1989fa","type":"spinner","vertical":""}},[_vm._v(" 定位中... ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }